// Payment status colors mapping
export const PAYMENT_STATUS_COLORS = {
  created: 'blue',
  processing: 'processing',
  paid: 'success',
  failed: 'error',
  refunded: 'cyan',
  partially_refunded: 'geekblue',
  disputed: 'volcano',
  default: 'default'
};

// Normalize various backend/payment provider statuses to our canonical ones
export const normalizePaymentStatus = (rawStatus) => {
  if (!rawStatus) return 'unknown';
  const status = String(rawStatus).toLowerCase();
  switch (status) {
    case 'created':
    case 'pending':
    case 'requires_payment_method':
    case 'requires_action':
    case 'processing':
      return status === 'pending' ? 'processing' : status;
    case 'paid':
    case 'succeeded':
    case 'success':
      return 'paid';
    case 'failed':
    case 'canceled':
    case 'cancelled':
      return 'failed';
    case 'refunded':
      return 'refunded';
    case 'partially_refunded':
    case 'partial_refund':
      return 'partially_refunded';
    case 'disputed':
      return 'disputed';
    default:
      return status;
  }
};

// Table pagination defaults
export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
  total: 0
}; 